/**
 * CZNA-241 / CZNA-319: bridge between the record picker (deep in the form tree)
 * and the form host that owns the snapshot/navigation.
 *
 * `RecordPickerSubfield` only has `control` for its own subfield — it cannot
 * reach the parent form's `getValues` / `activeTabIndex`. `RecordForm` (the form
 * host) owns those, so it provides this context. The picker calls
 * `proposeAuthority(targetSubfieldPath, seedText, targetRecordType)` with its own
 * subfield path (e.g. "fields.370.0.a"), the cataloger's typed seed, AND the
 * target authority type it points at (from `subfieldDef.recordType`); RecordForm
 * builds the snapshot and navigates to that type's create route.
 *
 * CZNA-319: `targetRecordType` makes the flow type-parametrized — the picker, not
 * the form host, decides which authority type is being proposed (GEOGRAPHIC today;
 * any allow-listed picker target later, without copying logic). The host no longer
 * hardcodes GEOGRAPHIC.
 *
 * Outside a provider the hook returns a no-op `proposeAuthority`, so the picker
 * renders harmlessly in contexts (e.g. unit tests, future hosts) that don't wire
 * the flow.
 */
import React, { createContext, useContext } from 'react';
var noop = function () { };
var ProposeAuthorityContext = createContext({
    proposeAuthority: noop,
});
export var ProposeAuthorityProvider = function (_a) {
    var proposeAuthority = _a.proposeAuthority, children = _a.children;
    return (React.createElement(ProposeAuthorityContext.Provider, { value: { proposeAuthority: proposeAuthority } }, children));
};
export var useProposeAuthority = function () {
    return useContext(ProposeAuthorityContext);
};
export default ProposeAuthorityContext;
